import React, { useEffect, useState } from 'react';
import DOMPurify from 'dompurify';

const SpecifiedCommercialTransactionsPage = () => {
  const [doc, setDoc] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;

    const fetchDoc = async () => {
      setLoading(true);
      setError('');

      try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/terms/current?type=tokushoho`, {
          credentials: 'include',
        });

        if (!res.ok) {
          throw new Error('failed');
        }

        const payload = await res.json();
        if (!cancelled) setDoc(payload);
      } catch (e) {
        if (!cancelled) setError('特定商取引法に基づく表示の取得に失敗しました。');
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    fetchDoc();
    return () => {
      cancelled = true;
    };
  }, []);

  const formatDate = (value) => {
    if (!value) return '-';
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return '-';
    return date.toLocaleString('ja-JP');
  };

  return (
    <div style={{ maxWidth: 900, margin: '0 auto', padding: '24px 16px 64px', lineHeight: 1.8 }}>
      <h1 style={{ marginTop: 0 }}>特定商取引法に基づく表示</h1>
      {loading && <p>読み込み中...</p>}
      {!loading && error && <p style={{ color: '#dc2626' }}>{error}</p>}
      {!loading && !error && doc && (
        <>
          <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(doc.content || '') }} />
        </>
      )}
    </div>
  );
};

export default SpecifiedCommercialTransactionsPage;
